import css from './App.css'

export const rootClassName = css.first_story__root

const storyConfig = {
  rootClassName,
  universeId: '1.14270701', // '1.13885661',
  docId: '1YGAuO-By2ObYe92QYcAZApqc16k2AUQAvHhh7JDKlQw' // '1cW7QvOT3UODwIzFM-BHlx6jctyJdBaO080I6NEMKAZI'
}

export default storyConfig
